import React, { Component } from 'react'
import PropTypes from 'prop-types'
import orgamax from 'ampersand-app'
import { EMPTY_CATEGORY } from '@/modules/article/model/article_model'

import settingsConfig from '@/modules/settings/config'
import SelectInput from '@/modules/base/components/inputs/select-input/select-input'
import lang from '@/lang'

import { toast } from '@/modules/base/components/toast/toastConfig'
import request from '@/modules/base/util/request'
import TextInput from '@/modules/base/components/inputs/text-input/text-input'
import MenuListWithCreate from '@/modules/base/components/inputs/select-input/menu-list-with-create'

class ArticleCategoryInput extends Component {
  constructor(props) {
    super(props)

    const { value } = props

    this.state = {
      value: value ? { name: value } : undefined,
      defaultCategory: { name: EMPTY_CATEGORY },
      categories: [],
      categorySelectOptions: [],
      isManualEntry: false,
      manualValue: '',
    }

    this.getCategories = this.getCategories.bind(this)
    this.onCategoryChange = this.onCategoryChange.bind(this)
    this.onCategoryCreated = this.onCategoryCreated.bind(this)
    this.getCategorySelectProps = this.getCategorySelectProps.bind(this)
    this.MenuList = props => <MenuListWithCreate {...props} onCreateClick={this.startManualEntry} />
    this.startManualEntry = this.startManualEntry.bind(this)
    this.cancelManualEntry = this.cancelManualEntry.bind(this)
    this.confirmManualEntry = this.confirmManualEntry.bind(this)
  }

  componentDidMount() {
    const { defaultCategory, value } = this.state
    const initialValue = value || defaultCategory
    this.setState({ defaultCategory, value: initialValue }, () => { this.onCategoryChange(initialValue) })
  }

  mapCategoriesToSelectOptions(categories) {
    return categories.map(category => ({ name: category }))
  }

  getCategories(search) {
    return new Promise((resolve, reject) => {
      request(settingsConfig.miscellaneousData, { auth: true, isConcurrent: true })
        .then((response) => {
          const { body: { data: { articleCategories: categories } } } = response

          const categorySelectOptions = this.mapCategoriesToSelectOptions(categories)
          this.setState({ categories, categorySelectOptions }, () => {
            if (search) {
              return resolve(categorySelectOptions.filter(category => category.name.toLowerCase().includes(search.toLowerCase())))
            }
            return resolve(categorySelectOptions)
          })
        })
        .catch(error => reject(error))
    })
  }

  getCategorySelectProps() {
    const { value, useFormik, label, name } = this.props
    const { categorySelectOptions } = this.state

    return {
      label,
      name,
      allowCreate: true,
      notAsync: false,
      customSelectOptions: {
        placeholder: lang.selectInput.createPlaceholder,
        valueKey: 'name',
        labelKey: 'name',
        isClearable: false,
        loadOptions: this.getCategories,
        defaultOptions: true,
      },
      options: categorySelectOptions,
      value: value ? { name: value } : { name: EMPTY_CATEGORY },
      useFormik,
      handleChange: this.onCategoryChange,
      onOptionCreated: this.onCategoryCreated,
      customComponents: { MenuList: this.MenuList },
    }
  }

  onCategoryChange(option) {
    const { onChange } = this.props
    this.setState({ value: option }, () => { onChange && onChange(option ? option.name : '') })
  }

  onCategoryCreated(option) {
    const { categories: actualCategories } = this.state
    const category = String(option).trim()
    const newCategories = [...actualCategories, category]

    request(settingsConfig.article, {
      auth: true,
      method: 'POST',
      data: { categories: newCategories },
    })
      .then(({ body: { data: { categories } } }) => {
        const categorySelectOptions = this.mapCategoriesToSelectOptions(categories)
        toast.showToast({ message: lang.article.categoryInput.optionCreated(category) })
        this.onCategoryChange({ name: category })
        this.setState({ categories, categorySelectOptions, isManualEntry: false, manualValue: '' })
      })
  }

  startManualEntry() {
    this.setState({ isManualEntry: true, manualValue: '' })
  }

  cancelManualEntry() {
    this.setState({ isManualEntry: false, manualValue: '' })
  }

  confirmManualEntry() {
    const { manualValue } = this.state
    const trimmed = (manualValue || '').trim()
    if (!trimmed) {
      this.cancelManualEntry()
      return
    }
    this.onCategoryCreated(trimmed)
  }

  render() {
    const { dataQsId } = this.props
    // necessary for refreshing options if a new one was created
    const categorySelectProps = this.getCategorySelectProps()
    const { isManualEntry, manualValue } = this.state

    if (isManualEntry) {
      return (
        <TextInput
          name={'category-manual'}
          value={manualValue}
          label={this.props.label}
          autoFocus
          useFormik={false}
          dataQsId={dataQsId}
          onChange={(val) => this.setState({ manualValue: val })}
          onEnter={this.confirmManualEntry}
          onBlur={this.confirmManualEntry}
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              e.preventDefault()
              this.cancelManualEntry()
            }
          }}
          customClass={null}
          className={null}
        />
      )
    }

    return (
      <SelectInput {...categorySelectProps} dataQsId={dataQsId} />
    )
  }
}

ArticleCategoryInput.propTypes = {
  value: PropTypes.string,
  useFormik: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  dataQsId: PropTypes.string.isRequired,
}

export default ArticleCategoryInput
